<template>
    <div class="stepsDetailP">
        <div id="amapContainer" style="width:100vw;height:100vh;"></div>
        <!-- <div class="notice">
          <van-notice-bar
              color="#ffffff" background="rgba(0,0,0,.3)"
              left-icon="volume-o"
              text="地图非真实比例地图，详细地址见点位信息。"
          />
        </div> -->
        <div class="star" v-if="userTaskInfo.currentFinished>9" @click="getcard"><img src="https://oss.mcloud.moveclub.cn/mpms/20210909/1631178225-6139cdf11f245.png" alt=""></div>
        <div class="header">
            <van-image :src="userInfo.userInfo.avatarurl"></van-image>
            <span>
            <ICountUp :endVal="userTaskInfo.totalSteps*1"/>
         </span>
         <span>自  {{userTaskInfo.join_start_time}}起累计</span>
        </div>
        <div class="footer">
            <div>
                <span>{{userTaskInfo.currentFinished}}/{{point.length}}</span>
                已点亮点位
            </div>
            <div v-if="userTaskInfo.show">
                <span>{{userTaskInfo.remain}}</span>
                可用步数
            </div>

            <div v-else>
                <span>{{userTaskInfo.join_start_time}}</span>
                累计步数
            </div>

            <div class="ai">
                <img src="https://oss.mcloud.moveclub.cn/mpms/20210909/1631172999-6139b987815a9.png" alt @click="aiShow=true"/>
            </div>
        </div>
        <van-overlay :show="show" class-name="van-overlay1" z-index="1001" @click="step=2;show=false">
          <div class="wrapper">
            <div class="over-btn">我知道了</div>
          </div>
        </van-overlay>
        <van-overlay :show="step==2" class-name="van-overlay2" z-index="1001" @click="getshow">
          <div class="wrapper2">
            <div class="over-btn" >我知道了</div>
          </div>
        </van-overlay>
        
        <Popup
          v-model="aiShow"
          get-container="#app"
          position="bottom"
          round
          :style="{ height: '70%',overflowY:'inherit' }"
        >
            <div class="aiDesc">
              <header v-if="userTaskInfo.show">
                <div>
                  <div>
                    <div>当前进度：<span>{{userTaskInfo.num>0?100:Math.round(userTaskInfo.remain*100/detail.step)}}</span><span style="font-size: .3rem;">%</span></div>
                    <div class="step"><span>可用步数</span> <span>{{userTaskInfo.remain}}步</span></div>
                  </div>
                  <div class="close-icon" @click="aiShow=false"><img src="https://oss.mcloud.moveclub.cn/mpms/20210910/1631244784-613ad1f0d3f78.png" alt=""></div>
                </div>
                <div>
                  <van-progress :percentage="userTaskInfo.num>0?100:userTaskInfo.remain/detail.step*100" :show-pivot="false" track-color="#7994AF" pivot-color="#FFAC39" stroke-width="0.21rem" color="linear-gradient(270deg, #FFDB00 41%, #FFAC39 100%)" />
                  <div class="tag"><span>0步</span><div class="remain" v-if="!userTaskInfo.num">还差{{detail.step - userTaskInfo.remain}}步点亮下个点位</div><span>{{detail.step}}步</span></div></div>
              </header>
              <header v-else>
                <div>
                  <div>
                    <div>当前进度：<span>100%</span></div>
                    <div class="step"><span>累计步数</span> <span>{{userTaskInfo.join_start_time}}步</span></div>
                  </div>
                  <div class="close-icon" @click="aiShow=false"><img src="https://oss.mcloud.moveclub.cn/mpms/20210910/1631244784-613ad1f0d3f78.png" alt=""></div>
                </div>
                <div>
                  <van-progress :percentage="100" :show-pivot="false" track-color="#7994AF" pivot-color="#FFAC39" stroke-width="0.21rem" color="linear-gradient(270deg, #FFDB00 41%, #FFAC39 100%)" />
                  <div class="tag"><span>0步</span><span>{{detail.step}}步</span></div>
                </div>
              </header>
              <div class="ai-body">
                <div class="ai-title">运动换步数</div>
                <div class="ai-item">
                  <div>
                    <img src="https://oss.mcloud.moveclub.cn/mpms/20210910/1631255191-613afa973d43b.png" alt="">
                    <div>
                      <div>走路</div>
                      <div>微信运动步数，每日最多10000步</div>
                    </div>
                  </div>
                  <div @click="getTaskList">
                    <img src="https://oss.mcloud.moveclub.cn/mpms/20210910/1631255149-613afa6dac086.png" alt="">
                  </div>
                </div>
                <div class="ai-item">
                  <div>
                    <img src="https://oss.mcloud.moveclub.cn/mpms/20210910/1631255164-613afa7c818cc.png" alt="">
                    <div>
                      <div>跳绳</div>
                      <div>跳一下可换算50步</div>
                    </div>
                  </div>
                  <div @click="goai(2915)">
                    <img src="https://oss.mcloud.moveclub.cn/mpms/20210910/1631255205-613afaa5d74d7.png" alt="">
                  </div>
                </div>
                <div class="ai-item">
                  <div>
                    <img src="https://oss.mcloud.moveclub.cn/mpms/20210910/1631255135-613afa5fc36e2.png" alt="">
                    <div>
                      <div>开合跳</div>
                      <div>1个开合跳可换算60步</div>
                    </div>
                  </div>
                  <div @click="goai(2916)">
                    <img src="https://oss.mcloud.moveclub.cn/mpms/20210910/1631255205-613afaa5d74d7.png" alt="">
                  </div>
                </div>
                <div class="ai-item">
                  <div>
                    <img src="https://oss.mcloud.moveclub.cn/mpms/20210910/1631255109-613afa45c5674.png" alt="">
                    <div>
                      <div>俯卧撑</div>
                      <div>1个俯卧撑可换算200步</div>
                    </div>
                  </div>
                  <div @click="goai(2917)">
                    <img src="https://oss.mcloud.moveclub.cn/mpms/20210910/1631255205-613afaa5d74d7.png" alt="">
                  </div>
                </div>
              </div>
              
            </div>
        </Popup>

        <Popup
          v-model="finshShow"
          get-container="#app"
          :close-on-click-overlay="false"
          :style="{ width: '80%',overflowY:'inherit',background:'transparent' }"
        >
            <div class="finshDesc">
              <header>
                <img src="https://oss.mcloud.moveclub.cn/mpms/20210910/1631241222-613ac40627c58.png" alt="">
                <div class="headertitle">【 {{activityPoints.title}} 】</div>
              </header>
              <div class="intro"
                      v-if="activityPoints.msg && activityPoints.futurecan*1">
                  您还可以继续点亮 <span style="color: #FF5D4B">{{activityPoints.futurecan}}</span>个地标<br>继续加油哦！
              </div>
              <div class="pon">
                <van-image :src="activityPoints.address" width="2.94rem" fit="contain">
                    <template v-slot:loading>
                        <Loading type="spinner" size="20" />
                    </template>
                </van-image>
              </div>
              
              <div class="button" @click="gonext">查看点位介绍</div>
            </div>
        </Popup>

        <Popup
          v-model="pointShow"
          get-container="#app"
          :style="{ width: '80%',overflowY:'inherit' }"
          round
          close-on-click-overlay
          @closed="closepointShow"
        >
            <div class="pointDescP">
                <img src="https://oss.mcloud.moveclub.cn/mpms/20210909/1631188088-6139f478297ba.png" alt="" class="tabc" @click="pointShow=false" >
                <van-image :src="activityPoints.address" width="2.2rem" fit="contain" style="opacity:0.5">
                    <template v-slot:loading>
                        <Loading type="spinner" size="20" />
                    </template>
                </van-image>
                <div class="p-b">
                    <header>
                        <img src="https://oss.mcloud.moveclub.cn/mpms/20210909/1631188365-6139f58d0453a.png" alt="">
                        <div class="headertitle">【 {{activityPoints.title}} 】</div>
                    </header>
                    

                    <div class="intro" v-if="activityPoints.description">
                        <div :style="{display:showMore?'block':'-webkit-box'}"><div v-html="activityPoints.description"></div></div>
                        <van-icon name="arrow-down" color="#999" @click="showMore=true" v-if="!showMore && activityPoints.description.length>=40"/>
                        <van-icon name="arrow-up" color="#999" @click="showMore=false" v-if="showMore && activityPoints.description.length>=40"/>
                    </div>

                    <div class="shortdesc">{{activityPoints.shortdesc}}</div>

                </div>
            </div>
        </Popup>
    </div>
</template>
<script>
    var points = [[[412,332], [228,627]],
      [[228,627], [108,672]],
      [[108,672], [629,879]],
      [[629,879], [228,909]],
      [[228,909], [295,443]],
      [[295,443], [170,998]],
      [[170,998], [375,492]],
      [[375,492], [529,372]],
      [[529,372], [569,452]],
      [[569,452], [499,252]],
      [[499,252], [559,1133]],
      [[559,1133], [629,1033]],
      [[629,1033], [130,811]],
      [[130,811], [148,443]],
      [[148,443], [359,599]],
      [[359,599], [228,363]],
      [[228,363], [512,639]],
      [[512,639], [549,719]],
      [[549,719], [599,799]],
      [[599,799], [412,332]]];
    for(var i = 0;i<points.length;i++){
      for(var j = 0;j<points[i].length;j++){
        points[i][j][0] = (points[i][j][0] - 359)*0.000004487*10 + 121.493356
        points[i][j][1] = ((1334-points[i][j][1]) - 667)*0.000003457*10 + 31.200089
      }
    }
    var offset = [
        [10, -55], //1
        [-60, -85], //2
        [-95, -40],//3
        [-80, -50],//4
        [-30, -80],//5
        [-25, -85],//6
        [10, -45],//7
        [0, -50],//8
        [-80, -50],//8
        [10, -50],//10
        [0, 0],//11
        [-55, 10],//12
        [-30, 0], //13
        [-30, 10],  //14
        [-50, 15], //15
        [-60, 0],
        [-90, -50],
        [0, -20],
        [-90, -30],
        [-10, 0],
        [-50, -50],
    ];
    var offset14 = [
        [0, -50], //1
        [-30, -65], //2
        [-70, -20],//3
        [-60, -30],//4
        [-20, -60],//5
        [-25, -65],//6
        [10, -45],//7
        [10, -30],//8
        [-50, -30],//9
        [20, -30],//10
        [0, 0],//11
        [-55, 10],//12
        [-20, 10], //13
        [-30, 10],  //14
        [-35, 5], //15
        [-40, 0],
        [-60, -30],
        [5, -10],
        [-60, -20],
        [-5, 5],
        [-30, -30],
    ];


    var arr = [];
    import {mapGetters} from "vuex";
    import PinchZoom from "vue-pinch-zoom";
    import {Button, Image, Loading, Swipe, SwipeItem, Popup, Collapse, CollapseItem, NoticeBar, RadioGroup, Radio, Overlay, Progress} from "vant";
    import Footbar from "@/components/footbar/index";
    import ICountUp from "vue-countup-v2";
    import {lazyAMapApiLoaderInstance} from "vue-amap";
    import moment from 'moment';
    // import VConsole from 'vconsole'

    const STEPS_COUNT = 8000;
    const JACKPOT = 919;
    export default {
        name: "checkDetail",
        computed: {
            ...mapGetters({
                userInfo: "getUserInfo"
            })
        },
        data() {
            return {
                // userInfo: {
                //   userInfo: {
                //     address: "",
                //     avatarurl: "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJJCPmOBLhIzmHNvb9rKMMk64tyhPXnK0YdluvfwwicAUeicbZGIGLoxFzW0CWMueZl5uoTdp3ThMtw/132",
                //     city: "",
                //     continue_sign: 0,
                //     continue_signin_score: 20,
                //     country: "China",
                //     coupon_count: "0",
                //     create_time: 1564628229,
                //     enurid: "ODRaK2pTbEdDVW89",
                //     gender: 1,
                //     grand_total_point: 0,
                //     id_number: "341182***4459",
                //     id_type: null,
                //     issignin: 0,
                //     language: "zh_CN",
                //     name: "李响",
                //     nickname: "Li.",
                //     openid: "oC8Xn5fDCAqyYccwapEjfM5VT964",
                //     phone: "15858214461",
                //     province: "",
                //     role: 0,
                //     signin_score: 0,
                //     status: 1,
                //     total_point: 0,
                //     totalpoint: 0,
                //     update_time: "2021-06-23 22:01:59",
                //     urid: 4848
                //   }
                // },
                showMore:false,
                activityPoints:{},
                collapsename: [],
                hasques: false,
                point: [],
                pointShow: false,
                pointShowFrom: 1,
                rulesShow: false,
                userTaskInfo: {
                    currentFinished: 0,
                    totalSteps: 0
                },
                sigining: false,
                freenum: 0,
                detail: {},
                markers:[],
                markers14:[],
                systime: '',
                answershow: false,
                lettersarr: [
                  "A",
                  "B",
                  "C",
                  "D",
                  "E",
                  "F",
                  "G",
                  "H",
                  "I",
                  "J",
                  "K",
                  "L",
                ],
                question: {},
                answer: [],
                bind_subid: '',
                drawshow: false,
                answererror: false,
                check: '',
                finished: 0,
                show: true,
                step: 1,
                finshShow: false,
                activity_sub_id: '',
                aiShow: false
            };
        },
        components: {
            Button,
            VanImage: Image,
            Footbar,
            Loading,
            Swipe,
            SwipeItem,
            ICountUp,
            Popup,
            PinchZoom,
            Collapse,
            CollapseItem,
            VanNoticeBar:NoticeBar,
          VanRadioGroup:RadioGroup,
          VanRadio:Radio,
          vanOverlay:Overlay,
          vanProgress:Progress
        },
        methods: {
          goai(val){
            this.$router.push({
              name:'sportsDetail',params:{'sports_id':12,'item_sub_id':val}
            })
          },
          gonext(){
            this.finshShow = false
            this.pointShow = true
          },
            getcard() {
              this.$api.activity
                  .getCert({id: this.$route.params.activity_id})
                  .then(res => {
                    wx.previewImage({
                      urls: [res.data.cert]
                    });
                  });
              return;
            },
            getshow() {
              this.step = 1
              this.$storage.set("isshow",'1')
            },
            handleSteps() {
                // if (this.sigining) return;
                // this.sigining = true;
                this.$toast.loading("处理中...");
                this.$api.steps.stepsCheckin(Object.assign({api_throw_exception: false,activity_sub_id:this.activity_sub_id}, this.$route.params)).then(
                    res => {
                        console.log(res,'res')
                        this.sigining = false;
                        this.$toast.clear();
                        if (+res.status !== 200) {
                            this.$toast({
                                type: 'html',
                                position: "bottom",
                                message: "<div style='display: flex;align-items: center;font-size:12px;'>" +
                                    "<img src='" + require("@/assets/img/steps/run.png") + "' style='width:.44rem;height:.44rem;margin-right: 5px;'>" + res.message + "</div>",
                                duration: 5000,
                                className: "bottomToast"
                            })

                            return;
                        }

                        let {finided, betweenSteps} = res.data;
                        this.activityPoints = Object.assign(finided,{playerInfo:{}});
                        this.userTaskInfo.totalSteps = betweenSteps;
                        this.finshShow = true;
                        this.getTaskList();

                    },
                    () => {

                    }
                );
            },

            getTaskList() {
                let that = this;
                new Promise(function (resolve, reject) {
                    //先清除所有的marker
                    that.map.remove(that.markers14)
                    that.map.remove(that.markers);
                    that.$api.activity.taskList(that.$route.params).then(res => {
                        if (res.status * 1 === 200) {
                            var {subList, intro, title, relation_actvity_id, relation_activity_type} = res.data;
                            var currentFinished = 0;

                            var finshedLine = [];
                            var finshedfirstpoint = [];
                            var markers = [];
                            var markers14 = [];

                            if(relation_actvity_id != ''&&relation_activity_type==5){
                              that.hasques = true
                            }

                            subList.forEach((item, index) => {
                                if (!!item.playerInfo) {
                                    currentFinished++;
                                    var icon = new AMap.Icon({
                                        size: new AMap.Size(120, 120),    // 图标尺寸
                                        image: item.imgurl,
                                        imageSize: new AMap.Size(120, 120),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon, // 添加 Icon 实例
                                        offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker.on('click', function (e) {
                                        that.markerClick(e)
                                    })


                                    var icon14 = new AMap.Icon({
                                        size: new AMap.Size(50,50),    // 图标尺寸
                                        image: item.imgurl,
                                        imageSize: new AMap.Size(50,50),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker14 = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon14, // 添加 Icon 实例
                                        offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker14.on('click', function (e) {
                                        that.markerClick(e)
                                    })


                                    var content = '<div class="first-pointx activity">' + (index+1) + "</div>";
                                    finshedfirstpoint.push(
                                        new AMap.Marker({
                                            position: points[index][points[index].length - 1],
                                            content,
                                            offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                            anchor: 'bottom-left', // 设置锚点方位
                                            zooms: [14,16],
                                            zoom: 15,
                                        })
                                    );
                                    finshedLine = finshedLine.concat(points[index])
                                  if(currentFinished==21){
                                    finshedLine = finshedLine.concat(points[index+1])
                                  }
                                } else {
                                    var icon = new AMap.Icon({
                                        size: new AMap.Size(120, 120),    // 图标尺寸
                                        image: item.icon,
                                        imageSize: new AMap.Size(120, 120),   // 根据所设置的大小拉伸或压缩图片
                                    });

                                    var marker = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon, // 添加 Icon 实例
                                        offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                        anchor: 'center', // 设置锚点方位
                                        title: index,
                                        zooms: [14,16],
                                        zoom: 15,
                                        zIndex:999

                                    });

                                    AMap.event.addListener(marker,'click',that.markerClick);

                                    marker.on('click', function (e) {
                                        that.markerClick(e)
                                    })



                                    var icon14 = new AMap.Icon({
                                        size: new AMap.Size(50, 50),    // 图标尺寸
                                        image: item.icon,
                                        imageSize: new AMap.Size(50, 50),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker14 = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon14, // 添加 Icon 实例
                                        offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker14.on('click', function (e) {
                                        that.markerClick(e)
                                    })
                                }
                                markers.push(marker);
                                markers14.push(marker14);
                            });
                            // 已经完成的创建折线实例
                            // if(finshedLine.length>0){
                            //     var polyline = new AMap.BezierCurve({
                            //         path: finshedLine,
                            //         lineJoin: "round",
                            //         lineCap: "round",
                            //         strokeWeight: 1,
                            //         strokeColor: "#FFFFFF",
                            //         outlineColor: "#FF5D51",
                            //         borderWeight: 4,
                            //         isOutline: true,
                            //         strokeStyle: "dashed"
                            //     });
                            //     polyline.setMap(that.map)
                            // }

                            that.markers = markers;
                            that.markers14 = markers14;

                            var zoom = that.map.getZoom()
                            if(zoom==14){
                                that.map.add(markers14)
                            }else{
                                that.map.add(markers);
                            }
                            that.map.add(finshedfirstpoint);
                            that.point = res.data.subList;                          
                            that.detail = res.data;
                            that.systime = res.timestamp
                            that.userTaskInfo.currentFinished = currentFinished;
                            that.userTaskInfo.join_start_time = moment(res.data.start_time*1000).format('MM月DD日');
                            let index = currentFinished - 1 <= 0 ? 0 : currentFinished - 1
                            index = index + 1 >= 20 ? 20 : (index + 1)
                            that.map.setCenter(
                                points[index][0]
                            );
                            resolve(Object.assign(res.data, {currentFinished}));
                        }
                    });
                }).then(e => {
                    let currentFinished = that.userTaskInfo.currentFinished
                    let {start_time, end_time, step,subList} = e;
                    that.$api.steps.stepsInfo(Object.assign({start_time, end_time}, that.$route.params)).then(res => {
                        if (+res.status === 200) {
                            let totalSteps = +res.data;
                            let remain = totalSteps - currentFinished*step
                            let num = Math.floor(remain/step)||0
                            let show = true
                            if(subList.length === currentFinished){
                              show = false
                            } else {
                              if(num>0){
                                num = num > subList.length - currentFinished ? subList.length - currentFinished : num
                              }
                            }
                            
                            console.log(num)
                            // this.activityPoints = subList[0]
                            // this.pointShow = true;
                            this.userTaskInfo = Object.assign(this.userTaskInfo, {
                                totalSteps,remain,num,show
                            });                           
                        }
                    });
                });
            },
            activityDetail: function () {
                this.$api.activity.activityDetail({acid: JACKPOT}).then(res => {
                    this.freenum = res.data.freenum;
                });
            },
            goluckdraw: function () {
                this.$router.push({name: "luckdraw", params: {acid: JACKPOT}});
            },
            markerClick: function (e) {
                let point = this.point[e.target.getTitle()];
                if(!!point.playerInfo){
                  this.activityPoints = point
                  this.pointShow = true;
                }else{
                  this.activity_sub_id = point.id
                  this.handleSteps()
                }
                // this.pointShow = true;
                // this.pointShowFrom = 2;
            },
            closepointShow: function () {
                this.pointShowFrom = 1;
                this.collapsename = []
                this.activityPoints= {}
            }
        },
        mounted() {
          // new VConsole()
          this.$storage.get("isshow").then((res) => {
            if (!!res) {
              this.show = false;
            } else {
              this.show = true;
            }
          });
            // this.$nextTick(() => {
            lazyAMapApiLoaderInstance.load().then(() => {
                var imageLayer = new AMap.ImageLayer({
                    url: "https://oss.mcloud.moveclub.cn/mpms/20210914/1631618563-614086036cb6f.png",
                    bounds : new AMap.Bounds(
                        [121.47231197,31.1710502], [121.51942547,31.229321392]
                    ),
                    zooms: [14,16],
                    zoom: 14,
                    opacity:.5
                });
                let layer_std = new AMap.TileLayer();
                this.map = new AMap.Map("amapContainer", {
                    resizeEnable: true,
                    center: [121.493356,31.200089],
                    zooms: [14,16],
                    zoom: 14,
                    layers: [layer_std, imageLayer],
                    mapStyle: "amap://styles/whitesmoke",
                });

                this.map.remove(layer_std);
                var linePoint = [];
                var firstPointMarkers = [];
                points.forEach((item, index) => {
                    linePoint = linePoint.concat(item);
                    var content = '<div class="first-pointx">' + index + "</div>";
                    if (index) {
                        firstPointMarkers.push(
                            new AMap.Marker({
                                position: item[0],
                                content,
                                animation:"AMAP_ANIMATION_DROP",
                                offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                anchor: 'bottom-left', // 设置锚点方位
                            })
                        );
                    }

                });
             //限制范围
                var bounds = new AMap.Bounds(
                    [121.47724767,31.17703081], [121.51090017,31.22314719]
                )
                this.map.setLimitBounds(bounds);
                this.map.add(firstPointMarkers);
                var that = this;
                setTimeout(() => {
                    // var polyline = new AMap.BezierCurve({
                    //     path: linePoint,
                    //     lineJoin: "round",
                    //     lineCap: "round",
                    //     strokeWeight: 1,
                    //     strokeColor: "#FFFFFF",
                    //     outlineColor: "#999999",
                    //     borderWeight: 4,
                    //     isOutline: true,
                    //     strokeStyle: "dashed"
                    // });
                    // polyline.setMap(that.map)
                    that.getTaskList();
                    // that.activityDetail();
                }, 1)

                this.map.setFeatures("building")

                this.map.on("click",function (e) {
                    console.log(e);
                })

                this.map.on('zoomend',function (e) {
                    var zoom = that.map.getZoom()
                    if(zoom==14){
                        that.map.remove(that.markers);
                        that.map.add(that.markers14)
                    }else{
                        that.map.remove(that.markers14)
                        that.map.add(that.markers);
                    }

                })



            });

            // })

        }
    };
</script>
<style lang="less">
    @import "Detail.less";
</style>
